export default "__VITE_ASSET__8PdgF2I$__"